/**
 * @file page
 * @author v_lichaoqing
 */

import {GET_CMSAPI_TAGARTICLEDATA} from '../actions/ActionTypes';

export function cmsapiTagArticleData(state = {}, action) {
    switch (action.type) {
        case GET_CMSAPI_TAGARTICLEDATA:
            if (action.data.is_error === 0) {
                if (action.isMore) {
                    action.data.itemlist.article_list.datalist.unshift(...state.itemlist.article_list.datalist);
                    return state = action.data;
                } else {
                    return state = action.data;
                }
            }
            return {};
        default:
            return state;
    }
}






// WEBPACK FOOTER //
// ./src/reducers/mark.js